import { z } from "zod/v4";
import { defineResource, defineEndpoint } from "@visioni/a3s-client-api";
import { SiteIdCodec } from "@visioni/a3s-schema/codecs";
import { FEATURE_NAME } from "../constants";

export const SiteListItem = z.object({
  siteId: SiteIdCodec,
  siteName: z.string(),
  timezone: z.string().nullable(),
  address: z.string().nullable(),
  crossStreet: z.string().nullable(),
  branchId: z.number(),
  branchName: z.string(),
});
export type SiteListItem = z.output<typeof SiteListItem>;

export const ListSitesResponse = z.object({
  sites: z.array(SiteListItem),
});
export type ListSitesResponse = z.output<typeof ListSitesResponse>;

export const sitesResource = defineResource({
  feature: FEATURE_NAME,
  resource: "sites",
  scope: "tenant",
});

export const listSitesEndpoint = defineEndpoint(sitesResource, {
  responseSchema: ListSitesResponse,
});
